import React, { useMemo } from "react";
import { Card, CardBody, Row } from "reactstrap";
import { Colxx } from "../../../../../../../components/common/CustomBootstrap";
import EmailLogo from '../../../../../../../assets/email_icon.png';
import WhatsApp_Logo from '../../../../../../../assets/whatsapp_icon.svg';
import SMS_Logo from '../../../../../../../assets/sms.svg';

const SummaryStatistics = ({ apiData = [] }) => {
    const stats = useMemo(() => {
        if (!Array.isArray(apiData) || apiData.length === 0) {
            return { whatsapp: 0, sms: 0, email: 0 };
        }

        let whatsappTotal = 0;
        let smsTotal = 0;
        let emailTotal = 0;

        apiData.forEach((item) => {
            item.channels?.forEach((ch) => {
                if (ch.channel === "Whatsapp") whatsappTotal += ch.count || 0;
                if (ch.channel === "SMS") smsTotal += ch.count || 0;
                if (ch.channel === "Email") emailTotal += ch.count || 0;
            });
        });

        return {
            whatsapp: whatsappTotal,
            sms: smsTotal,
            email: emailTotal,
        };
    }, [apiData]);

    const StatBox = ({ icon, title, value, iconStyle = {} }) => (
        <Card>
            <CardBody className="text-center">
                <img
                    src={icon}
                    alt={title}
                    style={{
                        width: 40,
                        height: 40,
                        marginBottom: 8,
                        ...iconStyle
                    }}
                />
                <p className="font-weight-semibold mb-0" style={{color:'#8f8f8f'}} >
                    {title}
                </p>
                <p className="lead text-center" style={{ fontSize: '1.2rem', color:'var(--theme-color-1)' }} >
                    {value}
                </p>
            </CardBody>
        </Card>
    );

    return (
        <Row className="mb-4">
            <Colxx xxs="12" md="4" className="mb-3">
                <StatBox icon={WhatsApp_Logo} title="Total WhatsApp" value={stats.whatsapp} />
            </Colxx>
            <Colxx xxs="12" md="4" className="mb-3">
                <StatBox icon={SMS_Logo} title="Total SMS" iconStyle={{ width: 26 }} value={stats.sms} />
            </Colxx>
            <Colxx xxs="12" md="4" className="mb-3">
                <StatBox icon={EmailLogo} title="Total Email" value={stats.email} />
            </Colxx>
        </Row>
    );
};

export default SummaryStatistics;
